<script setup lang="ts">
/**
 * @name WidgetWithExtraProps
 * @description Sample widget to demonstrate the use of the "extraProps"
 * @param props
 */
import type { IDashboardWidgetProps, TWidgetEmits } from '@tenorlab/vue-dashboard'
import { DashboardWidgetBase, WrapperColumnContent, useWidgetEmits } from '@tenorlab/vue-dashboard'
import { computed } from 'vue'

const props = defineProps<IDashboardWidgetProps>()
const emits = defineEmits<TWidgetEmits>()
const emitHandlers = useWidgetEmits(emits)

const extraProps = computed(() => props.extraProps)
const notificationsCount = computed(() => `${extraProps?.value?.notificationsCount || 'N/A'}`)
const messages = computed(() => extraProps?.value?.messages || [])
</script>

<template>
  <DashboardWidgetBase v-bind="props" v-on="emitHandlers">
    <WrapperColumnContent addCssClasses="gap-2">
      <div class="text-sm">Notifications</div>
      <div class="dashboard-number number-base text-primary">{{ notificationsCount }}</div>
      <dl class="flex flex-col gap-1 text-secondary outline w-full">
        <dd v-for="m in messages" :key="m.id">{{ m.title }}</dd>
      </dl>
      <div class="text-sm">Sample widget to show the use of "extraProps"</div>
    </WrapperColumnContent>
  </DashboardWidgetBase>
</template>
